// import { useEffect, useRef, useState } from "react";
// import {
//   Box,
//   Grid,
//   Typography,
//   Container,
// } from "@mui/material";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CloseIcon from "@mui/icons-material/Close";
// import IconButton from "@mui/material/IconButton";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import AdvisorImage from "../../assets/virtual-advisor.png";
// import LoginQRModal from "../../components/LoginQRModal ";
// import { CustomButton } from "../../utils/CustomTagComponents";
// import dayjs from "dayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
// import { TimeClock } from "@mui/x-date-pickers/TimeClock";
// import { checkFirstMeetingAPI, createMeeting, createOrderAPI, verifyPaymentAPI } from "../../services/VirtualMeetService";
// import { useSelector } from "react-redux";
// import { showToast } from "../../components/common/Toast";
// // import PhoneInput from "react-phone-input-2";
// // import "react-phone-input-2/lib/material.css";

// const VirtualOfficeSection = () => {
//   // const [phone, setPhone] = useState("");
//   const hideTimerRef = useRef(null);
//   const { auth } = useSelector((state) => state.auth || {});
//   const isLoggedIn = Boolean(auth?.idToken || auth?.localId || auth?.email);

//   const [meetingLink, setMeetingLink] = useState("");
//   const [copied, setCopied] = useState(false);
//   const [dateTime, setDateTime] = useState(dayjs());
//   const [timeView, setTimeView] = useState("hours");
//   const [showMeetingLabel, setShowMeetingLabel] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [loginModalOpen, setLoginModalOpen] = useState(false);
//   const now = dayjs();
//   const isToday = dateTime.isSame(now, "day");
//   const DEFAULT_HOUR = 9;
//   const DEFAULT_MINUTE = 0;

//   useEffect(() => {
//     if (showMeetingLabel) {
//       hideTimerRef.current = setTimeout(() => {
//         setShowMeetingLabel(false);
//         setCopied(false);
//       }, 15000);
//     }

//     return () => {
//       if (hideTimerRef.current) {
//         clearTimeout(hideTimerRef.current);
//       }
//     };
//   }, [showMeetingLabel]);

//   const handleCloseLabel = () => {
//     if (hideTimerRef.current) {
//       clearTimeout(hideTimerRef.current);
//     }
//     setShowMeetingLabel(false);
//     setCopied(false);
//   };

//   // const now = dayjs();
//   // const WORK_START_HOUR = 10;
//   // const WORK_END_HOUR = 18; // exclusive
//   // const WORK_DAYS = [1, 2, 3, 4, 5, 6]; // Mon–Sat

//   // 1️⃣ Open Google OAuth popup and wait for result
//   const openGoogleAuthPopup = () => {
//     return new Promise((resolve, reject) => {
//       const width = 600;
//       const height = 600;
//       const left = window.screen.width / 2 - width / 2;
//       const top = window.screen.height / 2 - height / 2;

//       console.log(process.env.REACT_APP_API_BASE_URL, "process.env.REACT_APP_API_BASE_URL")

//       const popup = window.open(
//         `${process.env.REACT_APP_API_BASE_URL}/auth/google`, // backend OAuth endpoint
//         "GoogleAuth",
//         `width=${width},height=${height},top=${top},left=${left}`
//       );

//       if (!popup) return reject("Popup blocked");

//       const messageHandler = (event) => {
//         if (event.origin !== process.env.REACT_APP_API_BASE_URL_PROD) return;
//         window.removeEventListener("message", messageHandler);
//         resolve(event.data);
//         popup.close();
//       };

//       window.addEventListener("message", messageHandler);

//       const interval = setInterval(() => {
//         if (popup.closed) {
//           clearInterval(interval);
//           window.removeEventListener("message", messageHandler);
//           reject("Popup closed by user");
//         }
//       }, 500);
//     });
//   };

//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = "https://checkout.razorpay.com/v1/checkout.js";
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const openRazorpay = async (amount) => {
//     const res = await loadRazorpayScript();
//     if (!res) {
//       alert("Razorpay SDK failed to load");
//       return false;
//     }

//     const { data } = await createOrderAPI({ amount });
//     if (!data.success) return false;

//     return new Promise((resolve, reject) => {
//       const options = {
//         key: process.env.REACT_APP_RAZORPAY_KEY_ID,
//         amount: data.order.amount,
//         currency: data.order.currency,
//         name: "Virtual Office",
//         description: "Consultation Payment",
//         order_id: data.order.id,
//         handler: async (response) => {
//           const verifyRes = await verifyPaymentAPI({
//             razorpay_order_id: response.razorpay_order_id,
//             razorpay_payment_id: response.razorpay_payment_id,
//             razorpay_signature: response.razorpay_signature,
//             amount,
//           });
//           if (verifyRes.data.success) resolve(true);
//           else reject("Payment verification failed");
//         },
//         theme: { color: "#F37254" },
//       };
//       const rzp = new window.Razorpay(options);
//       rzp.on("payment.failed", (response) => reject(response.error.description));
//       rzp.open();
//     });
//   };

//   // 2️⃣ Handle join button click
//   const handleJoinVirtualOffice = async () => {
//     try {
//       if (!isLoggedIn) {
//         setLoginModalOpen(true);
//         return;
//       }

//       setLoading(true);

//       // const { data: check } = await checkFirstMeetingAPI();
//       // console.log("First meeting check:", check);

//       // if (!check.isFirstMeeting && check.paymentRequired) {
//       //   // Trigger Razorpay popup directly on user click
//       //   const paid = await openRazorpay(check.amount);
//       //   if (!paid) {
//       //     setLoading(false);
//       //     return;
//       //   }
//       // }

//       // 🔹 Step 1: Google OAuth
//       const googleData = await openGoogleAuthPopup();

//       if (!googleData.success) {
//         alert("Google login failed");
//         setLoading(false);
//         return;
//       }

//       // 🔹 Step 2: Create meeting via VirtualMeetService
//       const { data } = await createMeeting({
//         startTime: dateTime.toISOString(),
//       });

//       console.log("Meeting creation response:", data);

//       setLoading(false);

//       if (data.success) {
//         // Open meet link in new tab
//         setMeetingLink(data.meetLink);
//         setShowMeetingLabel(true);

//         // ⏳ Hide after 15 seconds
//         setTimeout(() => {
//           setShowMeetingLabel(false);
//         }, 15000);
//         // window.open(data.meetLink, "_blank");
//       } else {
//         alert(data.message);
//       }
//     } catch (err) {
//       console.error(err);
//       showToast(err?.message || "Cancelled by user", "error");
//       setLoading(false);
//     }
//   };

//   const handleCopy = async () => {
//     try {
//       await navigator.clipboard.writeText(meetingLink);
//       setCopied(true);

//       // reset after 2 sec (optional)
//       setTimeout(() => setCopied(false), 2000);
//     } catch (err) {
//       showToast("Failed to copy", "error");
//     }
//   };

//   return (
//     <>
//       <Container sx={{ py: 6 }}>
//         <Grid
//           container
//           spacing={4}
//           alignItems="center"
//           justifyContent="center"
//           sx={{
//             backgroundColor: "#FFF4E6",
//             borderRadius: "20px",
//           }}
//         >
//           <Grid size={{ xs: 12, md: 6 }}>
//             <Box
//               sx={{
//                 p: { xs: 3, sm: 5 },
//                 height: "100%",
//               }}
//             >
//               <Typography
//                 variant="h5"
//                 fontWeight={700}
//                 sx={{
//                   fontSize: { xs: 30, sm: 40 },
//                   fontWeight: 700,
//                   color: "#000000",
//                   lineHeight: "28px",
//                   letterSpacing: "0.89px",
//                   mb: 3,
//                 }}
//               >
//                 We Are Online
//               </Typography>
//               <Typography
//                 variant="h5"
//                 fontWeight={700}
//                 sx={{
//                   fontSize: { xs: 30, sm: 40 },
//                   fontWeight: 700,
//                   color: "#000000",
//                   lineHeight: "28px",
//                   letterSpacing: "0.89px",
//                   mb: 3,
//                 }}
//               >
//                 Meet Our Advisors Now
//               </Typography>
//               <Typography
//                 sx={{
//                   fontSize: { xs: 16, sm: 20 },
//                   fontWeight: 700,
//                   color: "#000000",
//                   lineHeight: "28px",
//                   letterSpacing: "0.89px",
//                   mb: 3,
//                 }}
//               >
//                 Select you preferred date & time to meet our virtual advisors
//                 instantly.
//               </Typography>

//               <LocalizationProvider dateAdapter={AdapterDayjs}>
//                 <Grid container spacing={4}>

//                   {/* 📅 DATE CALENDAR */}
//                   <Grid size={{ xs: 12, md: 6 }}>

//                     {/* <DateCalendar
//                     value={dateTime}
//                     minDate={now}
//                     shouldDisableDate={(date) => !WORK_DAYS.includes(date.day())}
//                     onChange={(newDate) => {
//                       if (!newDate) return;

//                       let newDateTime;

//                       if (newDate.isSame(now, "day")) {
//                         // Today → next valid working time
//                         const nextTime = now.hour() < WORK_START_HOUR
//                           ? newDate.hour(WORK_START_HOUR).minute(0)
//                           : now.add(5, "minute");

//                         newDateTime = nextTime;
//                       } else {
//                         newDateTime = newDate
//                           .hour(WORK_START_HOUR)
//                           .minute(0);
//                       }

//                       setDateTime(newDateTime);
//                       setTimeView("hours"); // reset hour picker
//                     }}
//                   /> */}


//                     <DateCalendar
//                       value={dateTime}
//                       minDate={dayjs()}
//                       onChange={(newDate) => {
//                         if (!newDate) return;

//                         let newDateTime;

//                         if (newDate.isSame(now, "day")) {
//                           newDateTime = now.add(5, "minute");
//                         } else {
//                           newDateTime = newDate
//                             .hour(DEFAULT_HOUR)
//                             .minute(DEFAULT_MINUTE);
//                         }

//                         setDateTime(newDateTime);

//                         // 🔥 Force hour selection again
//                         setTimeView("hours");
//                       }}
//                     />
//                   </Grid>

//                   {/* ⏰ TIME CLOCK */}
//                   <Grid size={{ xs: 12, md: 6 }}>

//                     {/* <TimeClock
//                     value={dateTime}
//                     minutesStep={5}
//                     view={timeView}
//                     onViewChange={setTimeView}
//                     shouldDisableTime={(value, view) => {
//                       // ⛔ Outside working hours
//                       if (view === "hours") {
//                         return value < WORK_START_HOUR || value >= WORK_END_HOUR;
//                       }

//                       // ⛔ Past minutes today
//                       if (view === "minutes") {
//                         if (!dateTime.isSame(now, "day")) return false;

//                         return (
//                           dateTime.hour() === now.hour() &&
//                           value < now.minute()
//                         );
//                       }

//                       return false;
//                     }}
//                     onChange={(newTime) => {
//                       const selected = dateTime
//                         .hour(newTime.hour())
//                         .minute(newTime.minute());

//                       // Safety fallback
//                       if (
//                         selected.hour() < WORK_START_HOUR ||
//                         selected.hour() >= WORK_END_HOUR
//                       ) {
//                         return;
//                       }

//                       if (selected.isBefore(now)) {
//                         setDateTime(now.add(5, "minute"));
//                       } else {
//                         setDateTime(selected);
//                       }
//                     }}
//                   /> */}

//                     <TimeClock
//                       value={dateTime}
//                       minutesStep={5}
//                       view={timeView}
//                       onViewChange={(view) => setTimeView(view)}
//                       minTime={isToday ? now : null}
//                       shouldDisableTime={(value, view) => {
//                         if (!isToday) return false;

//                         if (view === "hours") {
//                           return value < now.hour();
//                         }

//                         if (view === "minutes") {
//                           return (
//                             dateTime.hour() === now.hour() &&
//                             value < now.minute()
//                           );
//                         }

//                         return false;
//                       }}
//                       onChange={(newTime) => {
//                         const selected = dateTime
//                           .hour(newTime.hour())
//                           .minute(newTime.minute());

//                         if (selected.isBefore(now)) {
//                           setDateTime(now.add(5, "minute"));
//                         } else {
//                           setDateTime(selected);
//                         }
//                       }}
//                     />
//                   </Grid>

//                 </Grid>
//               </LocalizationProvider>

//               <Box mt={3} p={2} bgcolor="#fff" borderRadius={2}>
//                 <Typography fontWeight={700}>
//                   Selected Date & Time
//                 </Typography>

//                 <Typography color="primary" fontSize={16}>
//                   {dateTime.format("DD MMM YYYY, hh:mm A")}
//                 </Typography>
//               </Box>

//               {showMeetingLabel && meetingLink && (
//                 <Box
//                   mt={2}
//                   p={2}
//                   display="flex"
//                   alignItems="center"
//                   justifyContent="space-between"
//                   bgcolor="#E8F5E9"
//                   borderRadius={2}
//                   gap={2}
//                 >
//                   <Typography fontWeight={600} color="success.main">
//                     Meeting link created successfully
//                   </Typography>

//                   <Box display="flex" alignItems="center" gap={1}>
//                     <CustomButton
//                       onClick={handleCopy}
//                       startIcon={
//                         copied ? (
//                           <CheckCircleIcon color="success" />
//                         ) : (
//                           <ContentCopyIcon />
//                         )
//                       }
//                       sx={{ minWidth: 140 }}
//                     >
//                       {copied ? "Copied" : "Copy Link"}
//                     </CustomButton>

//                     {/* ❌ Close Button */}
//                     <IconButton onClick={handleCloseLabel} size="small">
//                       <CloseIcon />
//                     </IconButton>
//                   </Box>
//                 </Box>
//               )}

//               <Box textAlign={"right"} mr={3} mt={3}>
//                 <CustomButton
//                   endIcon={<ArrowForwardIcon />}
//                   sx={{
//                     maxWidth: 500,
//                     width: "100%",
//                     borderRadius: "20px",
//                   }}
//                   onClick={handleJoinVirtualOffice}
//                 >
//                   Join Virtual Office Now
//                 </CustomButton>
//               </Box>
//             </Box>
//           </Grid>

//           <Grid size={{ xs: 12, md: 6 }} pl={{ xs: 0, md: 5 }} style={{ height: '-webkit-fill-available' }}>
//             <Box
//               component="img"
//               src={AdvisorImage}
//               alt="Advisor Session"
//               sx={{
//                 height: "inherit",
//                 width: "100%",
//                 marginBottom: "-5px",
//                 borderRadius: { xs: "20px", md: 0 },
//               }}
//             />
//           </Grid>
//         </Grid>
//       </Container>
//       {loginModalOpen && (
//         <LoginQRModal open={loginModalOpen} handleClose={() => setLoginModalOpen(false)} />
//       )}
//     </>
//   );
// };

// export default VirtualOfficeSection;
// import { useState } from "react";
// import {
//   Box,
//   Grid,
//   Typography,
//   Container,
//   IconButton,
// } from "@mui/material";

// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CloseIcon from "@mui/icons-material/Close";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// import { InlineWidget, useCalendlyEventListener } from "react-calendly";

// import { useSelector } from "react-redux";

// import AdvisorImage from "../../assets/virtual-advisor.png";
// import LoginQRModal from "../../components/LoginQRModal ";
// import { CustomButton } from "../../utils/CustomTagComponents";
// import { showToast } from "../../components/common/Toast";

// const CALENDLY_URL = "https://calendly.com/rakesh-kretoss/30min"; // 🔴 Change this

// const VirtualOfficeSection = () => {
//   const { auth } = useSelector((state) => state.auth || {});
//   const isLoggedIn = Boolean(auth?.idToken || auth?.email);

//   const [meetingLink, setMeetingLink] = useState("");
//   const [copied, setCopied] = useState(false);
//   const [showMeetingLabel, setShowMeetingLabel] = useState(false);
//   const [loginModalOpen, setLoginModalOpen] = useState(false);

//   /* ✅ Listen for successful booking */
//   useCalendlyEventListener({
//     onEventScheduled: (e) => {
//       const payload = e.data.payload;

//       setMeetingLink(payload.event.uri);
//       setShowMeetingLabel(true);

//       showToast("Meeting booked successfully!", "success");

//       // Auto hide after 15 sec
//       setTimeout(() => {
//         setShowMeetingLabel(false);
//       }, 15000);
//     },
//   });

//   /* ✅ Copy meeting link */
//   const handleCopy = async () => {
//     try {
//       await navigator.clipboard.writeText(meetingLink);
//       setCopied(true);

//       setTimeout(() => setCopied(false), 2000);
//     } catch {
//       showToast("Copy failed", "error");
//     }
//   };

//   /* ✅ Button Click */
//   const handleJoin = () => {
//     if (!isLoggedIn) {
//       setLoginModalOpen(true);
//       return;
//     }

//     document
//       .getElementById("calendly-section")
//       ?.scrollIntoView({ behavior: "smooth" });
//   };

//   return (
//     <>
//       <Container sx={{ py: 6 }}>
//         <Grid
//           container
//           spacing={4}
//           alignItems="center"
//           justifyContent="center"
//           sx={{
//             backgroundColor: "#FFF4E6",
//             borderRadius: "20px",
//             overflow: "hidden",
//           }}
//         >
//           {/* LEFT SIDE */}
//           <Grid size={{ xs: 12, md: 6 }}>
//             <Box
//               sx={{
//                 p: { xs: 3, sm: 5 },
//               }}
//             >
//               {/* Heading */}
//               <Typography
//                 sx={{
//                   fontSize: { xs: 28, sm: 38 },
//                   fontWeight: 700,
//                   mb: 1,
//                 }}
//               >
//                 We Are Online
//               </Typography>

//               <Typography
//                 sx={{
//                   fontSize: { xs: 28, sm: 38 },
//                   fontWeight: 700,
//                   mb: 2,
//                 }}
//               >
//                 Meet Our Advisors Now
//               </Typography>

//               <Typography
//                 sx={{
//                   fontSize: { xs: 15, sm: 18 },
//                   fontWeight: 600,
//                   mb: 3,
//                 }}
//               >
//                 Select your preferred date & time to meet our virtual advisors
//                 instantly.
//               </Typography>

//               {/* 📅 CALENDLY */}
//               <Box
//                 id="calendly-section"
//                 sx={{
//                   background: "#fff",
//                   borderRadius: "16px",
//                   p: 2,
//                   mb: 3,
//                   height: "520px",
//                   overflow: "hidden",
//                   position: "relative",
//                   boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
//                 }}
//               >
//                 <InlineWidget
//                   url={CALENDLY_URL}
//                   styles={{
//                     height: "100%",
//                     width: "100%",
//                   }}
//                   prefill={{
//                     email: auth?.email || "",
//                     name: auth?.name || "",
//                   }}
//                   pageSettings={{
//                     backgroundColor: "ffffff",
//                     primaryColor: "fd0000",
//                     textColor: "000000",
//                     hideEventTypeDetails: true,
//                     hideLandingPageDetails: false,
//                   }}
//                 />
//               </Box>

//               {/* ✅ Success Box */}
//               {showMeetingLabel && meetingLink && (
//                 <Box
//                   mt={2}
//                   p={2}
//                   display="flex"
//                   alignItems="center"
//                   justifyContent="space-between"
//                   bgcolor="#E8F5E9"
//                   borderRadius={2}
//                   gap={2}
//                 >
//                   <Typography fontWeight={600} color="success.main">
//                     Meeting booked successfully
//                   </Typography>

//                   <Box display="flex" alignItems="center" gap={1}>
//                     <CustomButton
//                       onClick={handleCopy}
//                       startIcon={
//                         copied ? (
//                           <CheckCircleIcon color="success" />
//                         ) : (
//                           <ContentCopyIcon />
//                         )
//                       }
//                       sx={{ minWidth: 130 }}
//                     >
//                       {copied ? "Copied" : "Copy Link"}
//                     </CustomButton>

//                     <IconButton
//                       size="small"
//                       onClick={() => setShowMeetingLabel(false)}
//                     >
//                       <CloseIcon />
//                     </IconButton>
//                   </Box>
//                 </Box>
//               )}

//               {/* BUTTON */}
//               <Box mt={3}>
//                 <CustomButton
//                   endIcon={<ArrowForwardIcon />}
//                   sx={{
//                     width: "100%",
//                     borderRadius: "30px",
//                     py: 1.5,
//                     fontSize: "16px",
//                     fontWeight: 600,
//                     background: "#fd0000",

//                     "&:hover": {
//                       background: "#d40000",
//                     },
//                   }}
//                   onClick={handleJoin}
//                 >
//                   Join Virtual Office Now
//                 </CustomButton>
//               </Box>
//             </Box>
//           </Grid>

//           {/* RIGHT IMAGE */}
//           <Grid size={{ xs: 12, md: 6 }}>
//             <Box
//               component="img"
//               src={AdvisorImage}
//               alt="Advisor Session"
//               sx={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "cover",
//                 borderRadius: { xs: "20px", md: 0 },
//               }}
//             />
//           </Grid>
//         </Grid>
//       </Container>

//       {/* LOGIN MODAL */}
//       {loginModalOpen && (
//         <LoginQRModal
//           open={loginModalOpen}
//           handleClose={() => setLoginModalOpen(false)}
//         />
//       )}
//     </>
//   );
// };

// export default VirtualOfficeSection;

import { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Container,
  IconButton,
} from "@mui/material";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { InlineWidget, useCalendlyEventListener } from "react-calendly";

import { useSelector } from "react-redux";

import AdvisorImage from "../../assets/expert.png";
import LoginQRModal from "../../components/LoginQRModal ";
import { CustomButton } from "../../utils/CustomTagComponents";
import { showToast } from "../../components/common/Toast";

const CALENDLY_URL = "https://calendly.com/rakesh-kretoss/30min";

const VirtualOfficeSection = () => {
  const { auth } = useSelector((state) => state.auth || {});
  const isLoggedIn = Boolean(auth?.idToken || auth?.email);

  const [meetingLink, setMeetingLink] = useState("");
  const [copied, setCopied] = useState(false);
  const [showMeetingLabel, setShowMeetingLabel] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);

  /* Listen for successful booking */
  useCalendlyEventListener({
    onEventScheduled: (e) => {
      const payload = e.data.payload;

      setMeetingLink(payload.event.uri);
      setShowMeetingLabel(true);

      showToast("Meeting booked successfully!", "success");

      setTimeout(() => {
        setShowMeetingLabel(false);
      }, 15000);
    },
  });

  /* Copy meeting link */
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(meetingLink);
      setCopied(true);

      setTimeout(() => setCopied(false), 2000);
    } catch {
      showToast("Copy failed", "error");
    }
  };

  /* Button click */
  const handleJoin = () => {
    if (!isLoggedIn) {
      setLoginModalOpen(true);
      return;
    }

    document
      .getElementById("calendly-section")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Container sx={{overflow:'hidden', py: { xs: 2, sm: 2, md: 3 },
        px: { xs: 3, sm: 4, md: 6 },
        paddingLeft: { xs: "24px !important", md: "48px !important" },
        paddingRight: { xs: "24px !important", md: "48px !important" }}}>
        <Grid
          container
          alignItems="stretch"
          justifyContent="center"
          sx={{
            backgroundColor: "#002045",
            borderRadius: "20px",
            overflow: "hidden",
            minHeight: "550px",
          }}
        >
          {/* LEFT SIDE */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                p: { xs: 3, sm: 5 },
              }}
            >
              {/* Headings */}
              {/* <Typography
                sx={{
                  fontSize: { xs: 28, sm: 38 },
                  fontWeight: 700,
                  color: "#ffffff",
                  lineHeight: { xs: "38px", sm: "48px" },
                }}
              >
                We Are Online
              </Typography> */}

              <Typography
                sx={{
                   fontSize: { xs: "22px", sm: "26px", md: "30px" },
                  color: "#ffffff",
                  fontWeight: 700,
                  lineHeight: { xs: "38px", sm: "48px" },
                  // letterSpacing:'0.89px'
                }}
              >
                Meet Our Advisor
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: 14, sm: 16 },
                  fontWeight: 600,
                  color: "#ffffff",
                  mb: 2,
                }}
              >
                Select your preferred date & time to meet our virtual advisor.
              </Typography>

              {/* CALENDLY */}
              <Box
                id="calendly-section"
                sx={{
                  background: "#fff",
                  borderRadius: "16px",
                  // p: 2,
                  // mb: 3,
                  height: "auto",

                  overflow: "hidden",
                  position: "relative",

                  boxShadow: "0 4px 20px rgba(0,0,0,0.05)",

                  /* Thin scrollbar */
                  "&::-webkit-scrollbar": {
                    width: "4px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#ddd",
                    borderRadius: "10px",
                  },
                }}
              >
                <InlineWidget
                  url={CALENDLY_URL}
                  styles={{
                    // height: "100%",
                    width: "100%",
                  }}
                  prefill={{
                    email: auth?.email || "",
                    name: auth?.name || "",
                  }}
                  pageSettings={{
                    backgroundColor: "ffffff",
                    primaryColor: "fd0000",
                    textColor: "000000",

                    hideEventTypeDetails: true,
                    hideLandingPageDetails: true,
                  }}
                />

                {/* Footer fade (visual trick) */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "40px",
                    background:
                      "linear-gradient(to top, white, rgba(255,255,255,0))",
                    pointerEvents: "none",
                  }}
                />
              </Box>

              {/* SUCCESS BOX */}
              {showMeetingLabel && meetingLink && (
                <Box
                  mt={2}
                  p={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  bgcolor="#E8F5E9"
                  borderRadius={2}
                  gap={2}
                >
                  <Typography fontWeight={600} color="success.main">
                    Meeting booked successfully
                  </Typography>

                  <Box display="flex" alignItems="center" gap={1}>
                    <CustomButton
                      onClick={handleCopy}
                      startIcon={
                        copied ? (
                          <CheckCircleIcon color="success" />
                        ) : (
                          <ContentCopyIcon />
                        )
                      }
                      sx={{ minWidth: 130 }}
                    >
                      {copied ? "Copied" : "Copy Link"}
                    </CustomButton>

                    <IconButton
                      size="small"
                      onClick={() => setShowMeetingLabel(false)}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>
                </Box>
              )}

              {/* BUTTON */}
              {/* <Box mt={3}>
                <CustomButton
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    width: "100%",
                    borderRadius: "30px",
                    py: 1.5,
                    fontSize: "16px",
                    fontWeight: 600,
                    background: "#fd0000",

                    "&:hover": {
                      background: "#d40000",
                    },
                  }}
                  onClick={handleJoin}
                >
                  Join Virtual Office Now
                </CustomButton>
              </Box> */}
            </Box>
          </Grid>

          {/* RIGHT IMAGE */}
          <Grid size={{ xs: 12, md: 6 }} sx={{
            display: "flex",
            alignItems: "stretch",
          }}>
            <Box
              component="img"
              src={AdvisorImage}
              alt="Advisor Session"
              sx={{
                width: "100%",
                height:'100%',
                objectFit: "cover",

                // Only outer corners rounded
                borderTopRightRadius: "20px",
                borderBottomRightRadius: "20px",

                borderTopLeftRadius: { xs: "20px", md: 0 },
                borderBottomLeftRadius: { xs: "20px", md: 0 },
              }}
            />
          </Grid>
        </Grid>
      </Container>

      {/* LOGIN MODAL */}
      {loginModalOpen && (
        <LoginQRModal
          open={loginModalOpen}
          handleClose={() => setLoginModalOpen(false)}
        />
      )}
    </>
  );
};

export default VirtualOfficeSection;
